"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var fonts_1 = __importDefault(require("./fonts"));
var colors = __importStar(require("./colors"));
var GlobalStyles = (0, styled_components_1.createGlobalStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  body {\n    font-family: 'GT America';\n    margin: 0;\n    padding: 0;\n    color: ", ";\n  }\n\n  a {\n    color: currentColor;\n    text-decoration: none;\n  }\n\n  * {\n    -webkit-font-smoothing: antialiased;\n    box-sizing: border-box;\n  }\n\n  ::selection {\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  ", "\n\n  body {\n    font-family: 'GT America';\n    margin: 0;\n    padding: 0;\n    color: ", ";\n  }\n\n  a {\n    color: currentColor;\n    text-decoration: none;\n  }\n\n  * {\n    -webkit-font-smoothing: antialiased;\n    box-sizing: border-box;\n  }\n\n  ::selection {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), fonts_1.default, colors.GREY_90, colors.BLUE_50, colors.WHITE);
exports.default = GlobalStyles;
var templateObject_1;
